/*
 * ===> 01 - Block Data
 * ===> 02 - WordPress Modules
 * ===> 03 - Register Block
 * ===> 03 - Block Save Mode [Output]
*/

//===> Block Data <===//
import Edit from './edit';
import metadata from './block.json';

//===> WordPress Modules <===//
import { registerBlockType } from '@wordpress/blocks';

//===> Register Block <===//
registerBlockType(metadata.name, {
    title      : metadata.title,
    category   : metadata.category,
    attributes : metadata.attributes,
    icon  : <svg fill="none" viewBox="0 0 30 30"><path fill="#000" fillRule="evenodd" d="M7.04 20.093c.44.254.92.374 1.4.374.52 0 1.04-.147 1.52-.44l1.227-.8c.733-.44 1.293-1.467 1.293-2.387v-3.867c0-.453.253-1.066.56-1.32L16.947 8.2c.586-.587 1.186-1.733 1.186-2.773V3.453a2.8 2.8 0 00-2.8-2.8H3.467c-1.574 0-2.8 1.28-2.8 2.894v2.066c0 .814.453 1.88 1.08 2.494l3.36 3.533c.28.333.506.92.506 1.267v4.76c0 1.013.534 1.92 1.427 2.426zM2.667 3.56c0-.507.346-.893.8-.893v-.014h11.866c.44 0 .8.36.8.8v1.974c0 .426-.32 1.08-.56 1.32l-3.84 3.4c-.733.626-1.253 1.786-1.253 2.84v3.866c0 .227-.187.6-.347.694l-1.24.8c-.293.186-.64.12-.853 0a.735.735 0 01-.413-.68v-4.76c0-.92-.494-1.947-1-2.574L3.187 6.72c-.294-.293-.52-.867-.52-1.093V3.56z" clipRule="evenodd"/><path fill="#000" d="M11 29.333h8c7.24 0 10.333-3.093 10.333-10.333v-8c0-4.613-1.266-7.48-3.96-9.013-.68-.387-1.866-.707-3.613-.987a1.003 1.003 0 00-1.147.827.99.99 0 00.827 1.146c2.027.32 2.733.64 2.947.76 2.04 1.16 2.946 3.4 2.946 7.267v8c0 6.147-2.186 8.333-8.333 8.333h-8c-6.147 0-8.333-2.186-8.333-8.333v-4c0-.547-.454-1-1-1-.547 0-1 .453-1 1v4C.667 26.24 3.76 29.333 11 29.333z"/><path fill="#000" d="M23 17.333h-6.667c-.546 0-1-.453-1-1 0-.546.454-1 1-1H23c.547 0 1 .454 1 1 0 .547-.453 1-1 1zM13.667 22.667H23c.547 0 1-.454 1-1 0-.547-.453-1-1-1h-9.333c-.547 0-1 .453-1 1 0 .546.453 1 1 1z"/></svg>,
    /**===> @see ./edit.js <===*/
    edit  : Edit,
    save  : () => null
});